<div #tempDoc id="tempDoc"></div>
<div id="parentDiv" appScrollSpy [spiedTags]="'div.pages'" (sectionChange)="onSectionChange($event)"
     [style.height.px]="documentHeight" style="overflow-y: scroll;">
  <div class="preview-mode-info">Preview mode <button matTooltip="Document in this view might look differently than the original document"></button></div>
  <div #el [style.transform]="scale" class="document-place" (mousedown)="deselect()" (mouseup)="selectText($event)"></div>
</div>
